import { ActionSource } from 'owa-mail-store';
import { SurfaceActionItem } from 'owa-surface-actions';

export default function getActionSource(
    item: SurfaceActionItem,
    actionSourceInProps: ActionSource
): ActionSource {
    let actionSource: ActionSource = 'RPCSAPinned';
    if (item?.renderedInOverflow) {
        if (item.isPinned) {
            actionSource = 'RPCSAOverflow';
        } else {
            actionSource = 'RPCSANotPinned';
        }
    }

    return actionSourceInProps ? actionSourceInProps : actionSource;
}
